import React, { Component } from 'react'
import StepZilla from "react-stepzilla";

import SelectSaleOrderStep from "./SelectSaleOrderStep";
import PaymentMethodStep from "./PaymentMethodStep";
import PayStep from "./PayStep";
import SuccessfulPaymentStep from './SuccessfulPaymentStep';

import { connect } from "react-redux"
import { scrollDashboardToTop } from "reducers/application/applicationActions"
import { updateMakeRequestQuotas } from "reducers/quotastopay/quotastopayActions"

import { withRouter } from 'react-router'

const steps = [
    { name: "1. Selección de Lote", component: <SelectSaleOrderStep /> },
    { name: "2. Método de Pago", component: <PaymentMethodStep /> },
    { name: "3. Pago", component: <PayStep /> },
    { name: "4. Resumen", component: <SuccessfulPaymentStep /> }
];

class PaymentWizard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentStep: 0
        }
    }

    componentWillMount() {

    }

    handleStepChange(step) {
        let variable = 1;
        if (step < this.state.currentStep) {
            let stepToDo = document.getElementsByClassName("progtrckr-todo")[0];
            let span = stepToDo.getElementsByTagName("span")[0];
            span.classList.remove("active-step");
            variable = 2;
        }

        let stepsDone = document.getElementsByClassName("progtrckr-done");
        for (let i = 0; i < stepsDone.length; i++) {
            const stepElement = stepsDone[i];
            let span = stepElement.getElementsByTagName("span")[0];
            console.log("span", span);
            if (i == (stepsDone.length - variable)) {
                span.classList.add("active-step");
            } else {
                span.classList.remove("active-step");
            }
        }

        switch (step) {
            case 1:
                {
                    this.props.scrollDashboardToTop();
                    this.props.updateMakeRequestQuotas(false);
                }
                break;

            case 2: {

            }
                break;
        }

        this.setState({ currentStep: step });
    }

    getStartStepIndex() {
        let startStepIndex = 0;
        const queryParams = this.props.location.search;
        const params = new URLSearchParams(queryParams.replace("?", ""));
        console.log("success", params.get('success'));
        if (params.get('success') === "true") {
            startStepIndex = 3;
        }
        return startStepIndex;
    }

    render() {
        let startStepIndex = this.getStartStepIndex();

        return (
            <StepZilla
                showSteps={true}
                nextTextOnFinalActionStep="Pagar"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                prevBtnOnLastStep={false}
                startAtStep={startStepIndex}
                steps={steps}
                dontValidate={false}
                stepsNavigation={true}
                nextButtonCls="btn btn-prev btn-info btn-fill pull-right btn-wd"
                backButtonCls="btn btn-next btn-default btn-fill pull-left btn-wd"
                hocValidationAppliedTo={[]}
                onStepChange={(step) => this.handleStepChange(step)}
            />
        )
    }
}


export default connect(
    null,
    { scrollDashboardToTop, updateMakeRequestQuotas },
    null,
    { withRef: true }
)(withRouter(PaymentWizard));


// WEBPACK FOOTER //
// ./src/components/PaymentWizard/PaymentWizard.jsx